import { ERequestStatus } from '../../../../types/requestStatus';
import { EAuthenticateStatus } from '../../../../types/authentication';
export function phoneSelector(state) {
  return state.authentication.twoFactor.phoneState.phone;
}
export function isSubmittingSelector(state) {
  return state.authentication.authenticate.status === EAuthenticateStatus.Loading || state.authentication.twoFactor.phoneState.status === ERequestStatus.Loading || state.authentication.authenticate.status === EAuthenticateStatus.Succeed;
}
export function resendTimeoutSelector(state) {
  return state.authentication.twoFactor.phoneState.secondsToRetry;
}
export function sendValidationCodeStatusSelector(state) {
  return state.authentication.twoFactor.phoneState.status;
}
export function hasAuthErrorSelector(state) {
  var _state$authentication = state.authentication.authenticate,
    authStatus = _state$authentication.status,
    authError = _state$authentication.error;
  var _state$authentication2 = state.authentication.twoFactor.phoneState,
    smsStatus = _state$authentication2.status,
    smsError = _state$authentication2.error;
  return authStatus === EAuthenticateStatus.Failed && authError !== undefined || smsStatus === ERequestStatus.Failed && smsError !== undefined;
}
export function authErrorSelector(state) {
  return hasAuthErrorSelector(state) ? state.authentication.authenticate.error || state.authentication.twoFactor.phoneState.error : undefined;
}